<template>
    <section class="tables">
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h2 class="card-title">{{ $t('names.documents.name') }}</h2>
                        <p class="card-description">{{ $t('names.documents.description') }}</p>
                        <b-table striped hover :items="aboutItems" :fields="fields" @row-clicked="editAboutItem" class="clickable"></b-table>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios'
import {Const} from '../../../main'

export default {
    name: 'AboutItemList',
    data() {
        return {
            aboutItems: [],
            fields: [
                {
                    key: 'id',
                    label: 'ID',
                    sortable: true,
                    thStyle: 'width: 75px;'
                },
                {
                    key: 'name',
                    label: this.$t('forms.name'),
                    sortable: true
                },
                {
                    key: 'key',
                    label: this.$t('forms.key'),
                    sortable: true
                }
            ]
        }
    },
    mounted() {
        axios.get(Const.API_HOST + '/admin/documents')
                .then(function (response) {
                    return response.data
                }).catch(function (error) {
            // eslint-disable-next-line no-console
            console.log(error)
        }).then(body => {
            this.aboutItems = body
        })
    },
    methods: {
        editAboutItem(item) {
            // eslint-disable-next-line no-console
            console.log(item)
            this.$router.push('/document/edit/' + item.id)
        }
    }
}
</script>

<style scoped>
.clickable /deep/ tbody td {
    cursor: pointer;
}

</style>
